export const AUX_API = process.env.REACT_APP_AUX_API_URL;